const clickChange = (button,block) => {

    let chips = document.querySelectorAll(button),
    blocks = document.querySelectorAll(block);


    [...chips][0]?.classList.add('active');
    [...blocks][0]?.classList.add('active-block');
   
    [...chips].forEach((item, idx) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        
        [...chips].map((it) => {
          it.classList.remove('active');
        });
        item.classList.add('active');

        [...blocks].map((it) => {
          it.classList.remove('active-block');
          [...blocks][idx].classList.add('active-block');
        });
      });
    });
}

export default clickChange;